import React, {useContext} from "react";
import {PortfolioContext} from '../../App';
import './Header.css';
import Resume from '../../usman.pdf';


const Header = () => {
    const portfolio = useContext(PortfolioContext);
    const name = portfolio['header']?.name || "";
    const description = portfolio['header']?.description || "";

    return (
        <div className="header-container">
            <h5 className="header-para1">Hi, my name is</h5>
            <p className="header-para2">{name}</p>
            <p className="header-para3">I build things for AI</p>
            <p className="header-para4">  {description} </p>
            <a href={Resume} target="_blank" className="primary-button">Check out my resume!</a>
        </div>
    )
}

export default Header;
